import React from 'react'
import { AthleteJersey } from '../common/Graphics'

const PlayerDetails = ({
  href = '#',
  img = '',
  name = '',
  team = '',
  isMedium = false
}) => {
  return (
    <div className="player-details">
      {
        img && !/default-player-logo/.test(img) ? 
        <a href={href} className="headshot-md athlete" dangerouslySetInnerHTML={{ __html: `<img data-src="${img}" class="lazyload"/>` }} />
        : <AthleteJersey href={href} isMedium={isMedium} /> }
      <div className="player-name"><span>{name}</span><span className="team">{team}</span></div>
    </div>
  )
}

export default PlayerDetails



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/PlayerDetails.jsx
 **/